import { handleSetPaging } from './handleSetPaging';

// ✅ Funkcija za setovanje page size iz Redux-a / State-a
export const handleSetPageSize = (pagesize, page, table) => {
  if (table) {
    table.setPageSize(pagesize);
    if (page) {
      handleSetPaging(page, table);
    }
  } else {
    console.error('Tabela nije inicijalizovana.');
  }
};
